import React from "react";

import { CalendarPageContext } from "~/calendar/CalendarPage";
import LoadingSpinner from "~/ui/LoadingSpinner";

import { SidePanelNavContext } from "../SidePanel";
import PanelToggler from "./PanelToggler";
import ViewOptionsMenu from "./ViewOptionsMenu";

import styles from "./RightToolbar.module.css";

export default function RightToolbar() {
	const { navState } = React.useContext(SidePanelNavContext);
	const { loadingEvents } = React.useContext(CalendarPageContext);

	return (
		<div className={styles.toolbar}>
			<div className={styles.wrapper}>
				{loadingEvents && (
					<div className={styles.itemWrapper}>
						<LoadingSpinner inline size="small" dimmer={false} delay={200} />
					</div>
				)}

				<ViewOptionsMenu />

				{navState.mode === "closed" && (
					<span className={styles.panelToggleContainer}>
						<PanelToggler />
					</span>
				)}
			</div>
		</div>
	);
}
